import React, { Component } from 'react'
import { Link } from 'react-router'
import AnimateReorder from 'react-flip-move'
import { Loader, ColorWay, Icon } from '@driftt/tide-core-legacy'
import { PhoenixStatus } from 'app/modules/presence/constants'
import PresenceFiltersRow from '../PresenceFiltersRow'
import NewPresenceRow from '../NewPresenceRow'

import './style.styl'

const PRESENCE_COLUMNS_NEW_LIVE_REVEAL = [
  { label: 'Action' },
  { label: 'Contact' },
  { label: 'Account', filter: true, filterPlaceholder: 'Account...', filterProperty: 'company.name' },
  { label: 'Current page', filter: true, filterPlaceholder: 'Page...', filterProperty: 'page.url' },
  { label: 'Time on site' },
  { label: 'Location', filter: true, filterPlaceholder: 'Location...', filterProperty: 'location' }
]

const PRESENCE_COLUMNS_NEW_LIVE_NO_REVEAL = [
  { label: 'Action' },
  { label: 'Contact' },
  { label: 'Current page', filter: true, filterPlaceholder: 'Page...', filterProperty: 'page.url' },
  { label: 'Time on site' },
  { label: 'Location', filter: true, filterPlaceholder: 'Location...', filterProperty: 'location' }
]

class PresenceTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      users: props.users.toArray(),
      hasReveal: props.hasReveal,
      tableColumns: PRESENCE_COLUMNS_NEW_LIVE_NO_REVEAL
    }
  }

  shouldComponentUpdate(nextProps) {
    return !this.props.paused && !nextProps.paused
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.users.equals(this.props.users)) {
      this.setState({
        users: nextProps.users.toArray()
      })
    }

    if (nextProps.hasLiveReveal) {
      this.setState({
        tableColumns: PRESENCE_COLUMNS_NEW_LIVE_REVEAL
      })
    }
  }

  renderColumnHeadings = () =>
    _.map(this.state.tableColumns, ({ label }) => (
      <th key={label}>
        <div>{label}</div>
      </th>
    ))

  isUserDisabled = user => {
    if (!!user.metasByRef) {
      status = user.metasByRef.first().phx_status
      return status === PhoenixStatus.DISCONNECTED
    } else {
      return false
    }
  }

  hasFilters = () => this.state.tableColumns.find(tc => tc.filter)

  renderUserRows = () => {
    const { handleStartConversationClick } = this.props
    const { users, hasReveal } = this.state

    if (users.length) {
      return users.map(user => (
        <NewPresenceRow
          user={this.props.paused && this.isUserDisabled(user) ? user.set('className', 'pr-user-disabled') : user}
          setSelectedUser={this.props.setSelectedUser}
          onStartConversationClick={handleStartConversationClick}
          key={user.id}
          hasReveal={hasReveal}
          hasLiveReveal={this.props.hasLiveReveal}
        />
      ))
    }
  }

  renderZeroState() {
    if (this.state.users.length) {
      return
    }


    const shouldShowLoadingState = this.props.presenceLoading

    if (!this.state.users.length && shouldShowLoadingState) {
      return (
        <div className="presence-zero-state loading">
          <Loader />
          <strong>Loading up your live view</strong>
        </div>
      )
    }

    //empty state no one online
    // if (!this.state.users.length && !this.props.counts.known && !shouldShowLoadingState) {
    if (!this.state.users.length && !shouldShowLoadingState) {
      return (
        <div className="presence-zero-state">
          <Icon name="cw-empty-search" />
          <strong>No one's live on your site right now.</strong>
          <p>
            Try adjusting your filters or head over to <br /> conversations to see who's chatting.
          </p>
          <Link to="/inboxes" className="drift-button">
            View conversations
          </Link>
        </div>
      )
    }

    //empty state from filters
    if (this.props.counts.online && !this.state.users.length && !shouldShowLoadingState) {
      return (
        <div className="presence-zero-state">
          <Icon name="cw-empty-search" />
          <strong>These don't seem like the results you're looking for.</strong>
          <p>
            It looks like no one matched what you searched for. <br /> Don't worry though, update your search terms and{' '}
            <br /> try again!
          </p>
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        {this.renderZeroState()}
        <table className="drift-table pr-table" ref="prTable">
          <thead>
            <tr>{this.renderColumnHeadings()}</tr>
            {this.hasFilters() && <PresenceFiltersRow tableColumns={this.state.tableColumns} />}
          </thead>
          <AnimateReorder
            easing="ease"
            enterAnimation="none"
            leaveAnimation="none"
            typeName="tbody"
            staggerDurationBy={15}
            staggerDelayBy={20}
            duration={700}
            delay={0}
          >
            {this.renderUserRows()}
          </AnimateReorder>
        </table>
      </div>
    )
  }
}

export default PresenceTable



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/PresenceTable/index.js